import React from 'react';
import PropTypes from 'prop-types';

const SuccessTile = props => (
  <div className="row offer">
    {props.image &&
    <div className="col-lg-2 centre">
      <img src={props.image} role="presentation" alt="Success" style={{ width: '100%' }} />
    </div>
    }
    <div className="col-lg-10 offer-success-message">
      <div className="offer-success-title">{props.title}</div>
      <div>
        {props.message}
      </div>
    </div>
  </div>
);

SuccessTile.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string
};

export default SuccessTile;



/** WEBPACK FOOTER **
 ** ./src/components/Success/SuccessTile.js
 **/